import BaseService from "./base.service";
import { CONFIG } from "@/config";
class RatingsService extends BaseService {
  get entity() {
    return "ratings";
  }

  getRatingByItemId(sectionItemId, saveInCache = false) {
    if (saveInCache && navigator.onLine) {
      caches
        .open(CONFIG.CACHEV)
        .then((cache) => {
          return cache.addAll([`/api/v1/${this.entity}/${sectionItemId}`]);
        })
        .catch((err) => console.log("err cache", err));
    }

    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${sectionItemId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  saveRating(rating) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`${this.entity}`, rating)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status)
            // console.log(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log(error.config)
        });
    });
  }
}

export default new RatingsService();
